import { h } from 'preact';

import { useTranslation } from '../../../i18n';

interface Props {
  message: string;
  close: () => void;
}

export const DownloadErrorModal = ({ message, close }: Props) => {
  const { t } = useTranslation();
  return (
    <div>
      <div class="single-modal-header">
        <h3 class="single-modal-title">{t('music.downloadUnavailable')}</h3>
      </div>
      <div class="single-modal-body">
        <p>{message}</p>
      </div>
      <div class="single-modal-footer inline--btns">
        <button class="btn button" onClick={close}>
          {t('common.ok')}
        </button>
      </div>
    </div>
  );
};
